import { useCallback, useRef } from 'react'

export const useDelayedAction = (duration = 10) => {
  const timeoutId = useRef<NodeJS.Timeout>()
  const performDelayedAction = useCallback(
    (action: () => void) => {
      if (timeoutId.current) clearTimeout(timeoutId.current)
      timeoutId.current = setTimeout(action, duration)
    },
    [timeoutId, duration]
  )
  return performDelayedAction
}
